// extracted by mini-css-extract-plugin
export default {"container":"AddCard_container__fW8-v"};